let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hpD3G")).then(() => parcelRequire('4alZ1'));